export { default as GroupListingPage } from './components/GroupListingPage';

export const GroupListingPageDynamic = () => import('./components/GroupListingPage');

export { default as GroupDetailsPage } from './components/GroupDetailsPage';

export const GroupDetailsPageDynamic = () => import('./components/GroupDetailsPage');

export { default as DeleteLearnersModal } from './components/modals/DeleteLearnersModal';
export { default as MixedAccessBulkModal } from './components/modals/MixedAccessBulkModal';

export { useCreateGroup } from './hooks/useCreateGroup';
export { useCreateGroupSubmit } from './hooks/useCreateGroupSubmit';
export { useGroupAdminEmailConflict } from './hooks/useGroupAdminEmailConflict';
export { getCreateGroupFieldErrors } from './utils/groupValidation';
export type { ConflictingAdminRole } from './utils/groupValidation';
export { MAX_GROUP_NAME_LENGTH } from './constants';
